export const HTTP_STATUS = Object.freeze({
  OK: 200,
  INTERNAL_SERVER_ERROR: 500,
  NOTFOUND: 404,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  BAD_REQUEST: 400
});
